import { QueryParameters } from "@faire/web-api/routes/cart";

export const buildServerCartQueryKey = (
  queryParams: QueryParameters,
  savedForLater: boolean
) => {
  return ["ServerBrandCarts", queryParams, savedForLater];
};

export const buildServerCartSummaryQueryKey = (
  queryParams: QueryParameters,
  selectedBrandTokens: string[]
) => {
  return ["ServerCartSummary", queryParams, selectedBrandTokens];
};
